"use strict";
/**
* Requests the browser to display the specified element in full-screen mode.
* This function handles compatibility across different browsers by checking
* for the appropriate full-screen request method.
*
* @param {HTMLElement} elem - The HTML element to be displayed in full-screen mode.
*/
function openInFullScreen(elem) {
    if (elem.requestFullscreen) {
        elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) { /* Safari */
        elem.webkitRequestFullscreen();
    } else if (elem.webkitEnterFullscreen) { /* Safari */
        elem.webkitEnterFullscreen();
    } else if (elem.msRequestFullscreen) { /* IE11 */
        elem.msRequestFullscreen();
    }
}

module.exports = function () {
    // banner custom video controller
    $("body").on("click", ".video-sound-controller-wrapper .video-control", function (e) {
        let $videoWrapper = $(e.currentTarget).closest(".video-sound-controller-wrapper");
        $videoWrapper.find("video").prop("muted", !$videoWrapper.find("video").prop("muted"));
        $videoWrapper.toggleClass("muted");
    });

    // banner custom fullscreen controller
    $("body").on("click", ".video-sound-controller-wrapper .video-control-fullscreen", function (e) {
        let $videoWrapper = $(e.currentTarget).closest(".video-sound-controller-wrapper");
        openInFullScreen($videoWrapper.find("video").get(0));
    });

    $("body").on("fullscreenchange", ".video-sound-controller-wrapper video", function () {
        let $videoEl = $(this);
        let $videoWrapper = $videoEl .closest(".video-sound-controller-wrapper");

        $videoWrapper.toggleClass("muted", true);
        $videoEl.prop("muted", true);
        $videoEl.trigger("play");
    });

    // safari custom event listener
    $(".video-sound-controller-wrapper video").on("webkitendfullscreen", function () {
        let $videoEl = $(this);
        let $videoWrapper = $videoEl .closest(".video-sound-controller-wrapper");

        setTimeout(function () {
            $videoWrapper.toggleClass("muted", true);
            $videoEl.prop("muted", true);
            $videoEl.trigger("play");
        }, 1000);
    });
};
